import React, { FunctionComponent } from 'react';
import { Box, DialogContentText, Typography } from '@mui/material';

import { Dialog } from '@paragon/popup-state';

interface RunWithMissingPricesDialogProps {
  readonly materials: readonly string[];
  readonly onClose: (runAnyway: boolean) => void;
}

/** Confirms running optimization when some materials will be excluded for lack of a price. */
export const RunWithMissingPricesDialog: FunctionComponent<RunWithMissingPricesDialogProps> = ({
  materials,
  onClose,
}) => (
  <Dialog
    insistent
    variant="design"
    title="Some materials have no price"
    submitText="Run anyway"
    cancelText="Go back"
    onSubmit={() => onClose(true)}
    onCancel={() => onClose(false)}
  >
    <DialogContentText>These materials have no price and will not be considered during optimization:</DialogContentText>
    <Box component="ul" sx={{ mt: 1, mb: 0, pl: 3 }}>
      {materials.map((material) => (
        <Typography component="li" variant="body2" key={material}>
          {material}
        </Typography>
      ))}
    </Box>
  </Dialog>
);
